import { useCallback, useEffect, useRef, useState } from "react";
import "../homepage/Homepage.scss";
import Eyes from "../../assets/homepage/eye_text.gif";
import EyesSP from "../../assets/homepage/eye_text.gif";
import Mouth from "../../assets/homepage/mouth_text.gif";
import MouthSP from "../../assets/homepage/mouth_text_SP.gif";
import Nature from "../../assets/homepage/2_nature_main.gif";
import NatureSP from "../../assets/homepage/nature_main.gif";
import Grid1 from "../../assets/homepage/grid/earthsongnew.webp";
import Grid2 from "../../assets/homepage/grid/grid2.webp";
import Grid3 from "../../assets/homepage/grid/grid3.webp";
import Grid4 from "../../assets/homepage/grid/grid4.webp";
import Grid5 from "../../assets/homepage/grid/grid5.webp";
import Grid6 from "../../assets/homepage/grid/grid6.webp";
import Grid7 from "../../assets/homepage/grid/grid7.webp";
import Grid8 from "../../assets/homepage/grid/grid8.webp";
import Grid9 from "../../assets/homepage/grid/grid9.webp";
import Grid10 from "../../assets/homepage/grid/grid10.webp";
import Grid11 from "../../assets/homepage/grid/grid11.webp";
import Grid12 from "../../assets/homepage/grid/grid12.webp";
import Grid13 from "../../assets/homepage/grid/grid13.webp";
import Grid14 from "../../assets/homepage/grid/youngbirds.png";
import Grid15 from "../../assets/homepage/grid/blacktajnew.webp";
import Grid16 from "../../assets/homepage/grid/grid18.webp";
import BottomBanner from "../../assets/homepage/lastimage.webp";
import MailIcon from "../../assets/homepage/mail icon.png";
import IGicon from "../../assets/homepage/ig.png";
import Ldnicon from "../../assets/homepage/linkdnicon.png";
import Loca from "../../assets/homepage/loca-icon.png";
import Footerlogo from "../../assets/homepage/footer-logo.webp";
import Phone from "../../assets/homepage/phone.png";
import LandingVideo from "../../assets/homepage/landing_logo.mp4";
import { Link } from "react-router-dom";
import icnos from "../../helpers/constants";
import Nav from "../../components/navbar/Nav";

const imageList = [
  {
    imageSrc: Grid1,
    class: "grid2",
    title: "earth song / summer house / ooty",
    url: "earth-song",
    id: "earth-song",
    text1: "earth song /",
    text2: "summer house /",
    text3: "ooty /",
    textBoxWidth: "52%",
  },
  {
    imageSrc: Grid2,
    class: "grid1",
    title: "uru / microbrewery / bangalore",
    url: "uru-brew",
    id: "uru-brew",
    text1: "uru /",
    text2: "microbrewery /",
    text3: "bangalore /",
    textBoxWidth: "48%",
  },
  {
    imageSrc: Grid3,
    class: "grid1",
    title: "gcbc / microbrewery / bangalore",
    url: "gcbc",
    id: "gcbc",
    text1: "gcbc /",
    text2: "microbrewery /",
    text3: "bangalore /",
    textBoxWidth: "48%",
  },
  {
    imageSrc: Grid4,
    class: "",
    title: "kaavu / restobar / bangalore",
    url: "kaavu",
    id: "kaavu",
    text1: "kaavu /",
    text2: "restobar /",
    text3: "bangalore /",
    textBoxWidth: "36%",
  },
  {
    imageSrc: Grid5,
    class: "",
    title: "social bellandur / restobar / bangalore",
    url: "social-bellandur",
    text1: "social bellandur /",
    text2: "restobar /",
    text3: "bangalore /",
    textBoxWidth: "56%",
  },
  {
    imageSrc: Grid6,
    class: "",
    title: "round / restaurant / thrissur",
    url: "round",
    text1: "round /",
    text2: "restaurant /",
    text3: "thrissur /",
    textBoxWidth: "37%",
  },
  {
    imageSrc: Grid7,
    class: "",
    title: "record room / restaurant / bangalore",
    url: "record-room",
    text1: "record room /",
    text2: "restaurant /",
    text3: "bangalore /",
    textBoxWidth: "42%",
  },
  {
    imageSrc: Grid8,
    class: "",
    title: "la casa / microbrewery / bangalore",
    url: "la-casa",
    text1: "la casa /",
    text2: "microbrewery /",
    text3: "bangalore /",
    textBoxWidth: "48%",
  },
  {
    imageSrc: Grid9,
    class: "",
    title: "manchanda / office / bangalore",
    url: "manchanda",
    id: "manchanda",
    text1: "manchanda /",
    text2: "office /",
    text3: "bangalore /",
    textBoxWidth: "40%",
  },
  {
    imageSrc: Grid10,
    class: "",
    title: "515 / office / bangalore",
    url: "p-515",
    text1: "515 /",
    text2: "office /",
    text3: "bangalore /",
    textBoxWidth: "36%",
  },
  {
    imageSrc: Grid11,
    class: "",
    title: "maratt / office / bangalore",
    url: "maratt",
    text1: "maratt /",
    text2: "office /",
    text3: "bangalore /",
    textBoxWidth: "35%",
  },
  {
    imageSrc: Grid12,
    class: "",
    title: "363 transit / office / bangalore ",
    url: "363-transit",
    text1: "363 transit /",
    text2: "office /",
    text3: "bangalore /",
    textBoxWidth: "38%",
  },
  {
    imageSrc: Grid13,
    class: "",
    title: "micelio / office / bangalore",
    url: "micelio",
    text1: "micelio /",
    text2: "office /",
    text3: "bangalore /",
    textBoxWidth: "35%",
  },
  {
    imageSrc: Grid14,
    class: "",
    title: "isle of the immmortals / competition",
    url: "isle-of-the-immmortals",
    id: "isle",
    text1: "isle of the immmortals /",
    text2: "competition /",
    textBoxWidth: "82%",
  },
  {
    imageSrc: Grid15,
    class: "",
    title: "black taj / competition",
    url: "black-taj",
    text1: "black taj /",
    text2: "competition /",
    textBoxWidth: "48%",
  },
  {
    imageSrc: Grid16,
    class: "",
    title: "center of excellence / competition",
    url: "center-of-excellence",
    text1: "center of excellence /",
    text2: "competition /",
    textBoxWidth: "73%",
  },
];

export default function HomePage() {
  const [isSticky, setIsSticky] = useState(false);
  const [isNavSticky, setIsNavSticky] = useState(false);

  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.setAttribute("muted", ""); // Important for iOS
      video.setAttribute("playsinline", ""); // Important for iOS
      video.play().catch((err) => {
        console.log("Autoplay blocked:", err);
      });
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const triggerPoint = window.innerHeight * 4;
      const navTriggerPoint = window.innerHeight * 0.5;
      setIsSticky(window.scrollY >= triggerPoint);
      setIsNavSticky(window.scrollY >= navTriggerPoint);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  let selectedIndex = localStorage.getItem("selectedImageIndex");

  const scrollToElement = useCallback(() => {
    const el = document.getElementById(selectedIndex);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedIndex]);

  //cache page function

  useEffect(() => {
    scrollToElement();
    const timeout = setTimeout(() => {
      requestAnimationFrame(scrollToElement);
      localStorage.removeItem("selectedImageIndex");
    }, 100); // delay can be tuned based on your app

    return () => clearTimeout(timeout);
  }, [scrollToElement]);

  //free scroll functionality

  const isScrolling = useRef(false);
  const scrollTimeout = useRef(null);

  useEffect(() => {
    const handleSmoothScroll = (event) => {
      const sections = document.querySelectorAll(".section");
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      let currentIndex = -1;
      sections.forEach((section, index) => {
        const sectionTop = section.offsetTop;
        const sectionBottom = sectionTop + section.offsetHeight;

        if (
          scrollY + windowHeight / 2 >= sectionTop &&
          scrollY + windowHeight / 2 < sectionBottom
        ) {
          currentIndex = index;
        }
      });

      if (currentIndex === -1 || currentIndex > 4) return;

      // Prevent default scroll
      event.preventDefault();

      // Avoid rapid firing due to trackpad
      if (isScrolling.current) return;

      // Set a minimum threshold for deltaY to avoid tiny scrolls triggering
      const SCROLL_THRESHOLD = 30;

      if (
        event.deltaY > SCROLL_THRESHOLD &&
        currentIndex < sections.length - 1
      ) {
        isScrolling.current = true;
        window.scrollTo({
          top: sections[currentIndex + 1].offsetTop,
          behavior: "smooth",
        });
      } else if (event.deltaY < -SCROLL_THRESHOLD && currentIndex > 0) {
        isScrolling.current = true;
        window.scrollTo({
          top: sections[currentIndex - 1].offsetTop,
          behavior: "smooth",
        });
      }

      clearTimeout(scrollTimeout.current);
      scrollTimeout.current = setTimeout(() => {
        isScrolling.current = false;
      }, 800); // Adjust as needed
    };

    window.addEventListener("wheel", handleSmoothScroll, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleSmoothScroll);
      clearTimeout(scrollTimeout.current);
    };
  }, []);

  // reverse free scroll function

  useEffect(() => {
    const enableSmoothScroll = () => {
      const sections = document.querySelectorAll(".section");
      if (sections.length > 0) {
        const section3Top = sections[4]?.offsetTop || 0;
        if (window.scrollY < section3Top) {
          // setSmoothScrollEnabled(true);
        }
      }
    };

    window.addEventListener("scroll", enableSmoothScroll);
    return () => window.removeEventListener("scroll", enableSmoothScroll);
  }, []);

  const handleImageClick = (index, url) => {
    localStorage.setItem("selectedImageIndex", url);
  };

  return (
    <>
      <title>Atto Atelier</title>
      <meta
        name="description"
        content="Explore our latest projects and related content showcasing our work."
      />
      <meta name="keywords" content="projects, portfolio, work, case studies" />
      <div id="homepage" className="home-page">
        <div id="home-header">
          <Nav
            isNavSticky={isNavSticky}
            scrollTop={isNavSticky ? true : false}
          />
          <div id="l" className="section landing-section">
            <section className="main-container container landing-image landing-logo flex justify align align-items-end">
              {/* <img src={Logo} alt="Logo" loading="lazy" /> */}
              <video
                ref={videoRef}
                className="landing-video"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{ display: "block" }}
              >
                <source src={LandingVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </section>
          </div>
          <div className="section dotted-bg">
            <div className="main-container">
              <section className="section-2 flex-justify-center">
                <div className="quote flex-justify-center">
                  <p>
                    poised between the forward thrust of culture <br />
                    and the grounded beauty of nature.
                  </p>
                </div>
              </section>
            </div>
          </div>
          <div className="section section-eye">
            <div className="main-container container">
              <section className="eyes flex-justify-center">
                <Link to="/man">
                  <picture>
                    <source media="(min-width: 1025px)" srcSet={Eyes} />
                    <source media="(min-width: 768px)" srcSet={Eyes} />
                    <img src={EyesSP} alt="Responsive" />
                  </picture>
                </Link>
              </section>
            </div>
          </div>
          <div className="section section-nature-desc">
            <section className="main-container flex-justify-center ">
              <div className="about flex-justify-center flex-column">
                <p>
                  architecture is a container for culture. <br />
                  when it is able to capture humanity's most noble <br />
                  aspirations, it becomes art.
                </p>
                <div className="culture-nature flex-justify-center">
                  <span>culture</span>{" "}
                  <Link to="/nature">
                    <picture>
                      <source media="(min-width: 1025px)" srcSet={Nature} />
                      <source media="(min-width: 768px)" srcSet={Nature} />
                      <img src={NatureSP} alt="Responsive" />
                    </picture>
                  </Link>
                </div>
                <p>
                  the architect is a gardener listening in on <br />
                  the story of the land. every site is deeply <br />
                  connected to an ecology and a social landscape.
                </p>
              </div>
            </section>
          </div>
          <div className="section section-cheeck">
            <section className="main-container container chin flex-justify-center">
              <Link to="/method">
                <picture>
                  <source media="(min-width: 1025px)" srcSet={Mouth} />
                  <source media="(min-width: 768px)" srcSet={Mouth} />
                  <img src={MouthSP} alt="Responsive" />
                </picture>
              </Link>
            </section>
          </div>
          {imageList?.map((item, index) => (
            <div
              key={index}
              id={item?.url}
              className={` ${
                index === 0 ? "section landing-prj-img" : " margin-15"
              } vertical-image-grid container `}
            >
              <div className="image-container">
                <div
                  className="image-text"
                  onClick={() => handleImageClick(index, item?.url)}
                >
                  <div className="wrapv d-none d-md-block d-lg-block">
                    <span className="vertical">{item.title}</span>
                  </div>
                  <Link to={`/${item?.url}`}>
                    <div
                      className={`mobile-text d-md-none d-lg-none ${
                        item.textBoxWidth ? item?.textBoxWidth : "fit-content"
                      }`}
                      style={{
                        width: item.textBoxWidth
                          ? item.textBoxWidth
                          : "fit-content",
                      }}
                    >
                      <div>{item.text1}</div>
                      <div>{item.text2}</div>
                      <div>{item.text3}</div>
                    </div>
                  </Link>
                  <Link to={`/${item?.url}`}>
                    <img src={item.imageSrc} alt="grid" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
          <div
            id="section3"
            className={` vertical-dotted-container ${
              isSticky ? "fixed-vertical-dot" : ""
            }`}
          ></div>
          <section id="find" className="section-footer-address">
            <div className="footer-address container flex-justify-center text-center">
              <div className="address">
                <div className="menu-icons">
                  <div className="triangle">
                    <img
                      src={Footerlogo}
                      className="triangle-img"
                      alt="triangle"
                    />
                    <div className="brand-name">
                      <p>atto atelier</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="social-container">
                <div className="social-icons">
                  <a href={icnos.location} rel="noreferrer" target="_blank">
                    <div className="icons">
                      <img src={Loca} alt="location" />
                    </div>
                  </a>
                  <a
                    href={icnos.phone}
                    rel="noreferrer"
                    target="_blank"
                    className="phone-wrapper"
                  >
                    <div className="icons">
                      <img src={Phone} alt="phone" />
                      <span className="phone-number">+91 8040124858</span>
                    </div>
                  </a>
                  <a href={icnos.mail} rel="noreferrer">
                    <div className="icons">
                      <img src={MailIcon} alt="fb" />
                    </div>
                  </a>
                  <a href={icnos.instagram} rel="noreferrer" target="_blank">
                    <div className="icons">
                      <img src={IGicon} alt="ig" />
                    </div>
                  </a>
                  <a href={icnos.linkDln} rel="noreferrer" target="_blank">
                    <div className="icons">
                      <img src={Ldnicon} alt="linkdln" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section className="section-footer-banner flex-justify-center">
            <div className="bottom-banner-container">
              <div className="footer-image-container flex-justify-center flex-column">
                <img
                  src={BottomBanner}
                  className="footer-banner"
                  alt="grid-images"
                />
              </div>
            </div>
          </section>
          <section className="section-footer-credits flex-justify-center align-items-end">
            <div className="credits-container text-center">
              <a
                href="https://www.instagram.com/eyeforitstudio/?igsh=dG9kNjQ2YmFhd2Nw#"
                rel="noreferrer"
                target="_blank"
              >
                <p>design // eyeforit studio</p>
              </a>
              <p>
                codes //{" "}
                <a
                  href="https://www.linkedin.com/in/vishnu-mk-3837781a0/"
                  rel="noreferrer"
                  target="_blank"
                >
                  vishnu
                </a>{" "}
                and{" "}
                <a
                  href="https://www.linkedin.com/in/faheem-moinudheen/"
                  rel="noreferrer"
                  target="_blank"
                >
                  faheem
                </a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
